import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Spinner from "../Spinner/Spinner";

const PrivateRoute = ({ children, allowedRoles, requiredPermissions }) => {
  const role = useSelector((state) => state.role ?? null);
  const permissions = useSelector((state) => state.permissions ?? []);
  const isLoggedIn = useSelector((state) => state.isLoggedIn);
  const authLoading = useSelector((state) => state.authLoading); // <-- new

  if (authLoading) return <Spinner loadingInfo="Loading..." />; // wait until auth status is known

  if (!isLoggedIn) return <Navigate to="/login" replace />;

  if (allowedRoles?.length > 0 && !allowedRoles.includes(role))
    return <Navigate to="/login" replace />;

  if (requiredPermissions?.length > 0 && !requiredPermissions.every(p => permissions.includes(p))) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;